
import Vue from 'vue'
import iView from 'view-design';
import VueI18n from 'vue-i18n'
import cookie from '@/assets/js/cookie.js'
import zhLocale from './lang/zh.js'
import enLocale from './lang/en.js'
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import $ from 'jquery';
Vue.use(VueI18n)
Vue.use(iView);
// Ready translated locale messages
let typeOfLanguage = cookie.get('language') || 'en'
const messages = {
	en: Object.assign(enLocale, en),
	zh: Object.assign(zhLocale, zh)

}
//判断浏览器语言
export default new VueI18n({
    locale:  typeOfLanguage, // set locale
    messages, // set locale messages
})





// WEBPACK FOOTER //
// ./src/i18n/i18n.js